import { isIOS } from "../../utils/isIOS";

export const scrollToElement = (elementName: string) => {
  const targetElement = document.getElementById(elementName);
  if (isIOS()) {
    window.scrollTo({
      top: targetElement?.offsetTop
    });
  } else {
    targetElement?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
